import './EmailAlertMetadataTab.scss';
import { capitalize } from '@sonar-software/sonar-ts-lib';
import { EmailAlertRecipientsList } from '@periscopes/general/email-alerts';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { SalesforceEmailTemplateRow } from '@periscopes/general/salesforce-email-templates/';
import { SalesforceEntityRow } from '@periscopes/general/entity';
import { usePeriscopeMetadata } from '@hooks';
import { COPY_SONAR_OBJECT_BASE, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSection, DetailSubsection } from '@periscopes/general';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
export const EmailAlertMetadataTab = ({ index, sonarObjectId }) => {
    var _a, _b, _c;
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.SalesforceWorkflowAlert);
    if (loading) {
        return React.createElement(LoadingSpinner, null);
    }
    return (React.createElement(DetailSection, { className: 'email-alert-details', spacing: 'small' },
        React.createElement(DetailSubsection, { spacing: 'none', title: capitalize(COPY_SPECIFIC.OBJECT) },
            React.createElement(SalesforceEntityRow, { parentIndex: index, record: {
                    displayName: (_a = metadata === null || metadata === void 0 ? void 0 : metadata.parentEntityName) !== null && _a !== void 0 ? _a : '',
                    sonarObjectId: Number(metadata === null || metadata === void 0 ? void 0 : metadata.parentEntitySonarObjectId)
                } })),
        React.createElement(DetailSubsection, { spacing: 'none', title: COPY_SONAR_OBJECT_BASE.EMAIL_TEMPLATE },
            React.createElement(SalesforceEmailTemplateRow, { parentIndex: index, record: {
                    displayName: (_b = metadata === null || metadata === void 0 ? void 0 : metadata.emailTemplateName) !== null && _b !== void 0 ? _b : '',
                    sonarObjectId: Number(metadata === null || metadata === void 0 ? void 0 : metadata.emailTemplateSonarObjectId)
                } })),
        React.createElement(DetailSubsection, { hidden: !(metadata === null || metadata === void 0 ? void 0 : metadata.recipients.length), spacing: 'none', title: COPY_SPECIFIC.RECIPIENTS },
            React.createElement(EmailAlertRecipientsList, { parentIndex: index, recipients: (_c = metadata === null || metadata === void 0 ? void 0 : metadata.recipients) !== null && _c !== void 0 ? _c : [] })),
        React.createElement(DetailSubsection, { spacing: 'none', title: COPY_SPECIFIC.CC_EMAILS },
            React.createElement("div", { className: 'cc-emails' }, metadata === null || metadata === void 0 ? void 0 : metadata.ccEmails))));
};
